import { Badge } from "@/components/ui/badge";

import type { PublicEchoFeedbackRecord } from "@/server/echoFeedback";
import { FeedbackCategoryIcon } from "./FeedbackCategoryIcon";

export const FeedbackCategoryChips = ({
  record,
}: {
  record: PublicEchoFeedbackRecord;
}) =>
  record.categories.length ? (
    <div className="flex flex-wrap gap-1.5">
      {record.categories.map((category) => (
        <Badge
          key={category.id}
          variant="secondary"
          className="gap-1 font-normal"
        >
          <FeedbackCategoryIcon iconKey={category.iconKey} className="size-3" />
          {category.label}
        </Badge>
      ))}
    </div>
  ) : (
    <Badge variant="outline" className="font-normal text-muted-foreground">
      Uncategorised
    </Badge>
  );
